import { Observable } from 'rxjs';
import { BaseChart } from 'src/app/core/data/model';

import { BlocEvent } from '../base-bloc';

// caller callback function type
export type ChartCardCallerCallBack<ChartData extends BaseChart> = () => Observable<ChartData | ChartData[] | number[]>;

export abstract class ChartsCardEvent extends BlocEvent {}

export class ChartsCardInitEvent<ChartData extends BaseChart> extends ChartsCardEvent {
  constructor(public caller: ChartCardCallerCallBack<ChartData>) {
    super();
  }
}
